// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__7MVr-","sendOtp":"AuthorizeToLogin_sendOtp__3-eEK"};